import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { ModalClose } from '../Modal.Close/Modal.Close.es.js';

const iconProps = {
    error: {
        className: 'bg-error text-icon-error',
        name: 'XCircleSolid'
    },
    info: {
        className: 'bg-info text-icon-info',
        name: 'InformationCircleSolid'
    },
    success: {
        className: 'bg-success text-icon-success',
        name: 'CheckCircleSolid'
    },
    warn: {
        className: 'bg-warning text-icon-warning',
        name: 'ExclamationSolid'
    }
};
const ModalTitle = ({ variant, iconName, className, children, ...props })=>{
    return jsxs("div", {
        className: classNames('cb-modal-title', className),
        "data-testid": "modal-title",
        ...props,
        children: [
            jsx(ModalClose, {}),
            variant && jsx("div", {
                className: "modal-title-icon",
                children: jsx(Icon.Circle, {
                    ...iconProps[variant],
                    name: iconName ?? iconProps[variant].name,
                    size: "default"
                })
            }),
            !variant && iconName && jsx("div", {
                className: "modal-title-icon",
                children: jsx(Icon, {
                    name: iconName,
                    size: 40
                })
            }),
            children
        ]
    });
};
ModalTitle.displayName = 'Modal.Title';

export { ModalTitle };
//# sourceMappingURL=Modal.Title.es.js.map
